<template>
  <div class="booking-summary text-start bg-black bg-opacity-10 rounded">
    <div
        v-if="booking.period" class="p-3">

      <div :class="{ 'd-flex align-items-center': getPeriodText(booking.period, 'name') }">
        <strong class="text-truncate" v-if="getPeriodText(booking.period, 'name')">{{ getPeriodText(booking.period, 'name') }}</strong>
        <strong class="ms-auto" v-if="totalAmount">{{ $n(totalAmount, 'currency') }}</strong>
      </div>

      <small class="d-block mt-2">
        {{ $t('from') }}: {{ booking.period.start | moment('ddd D MMM - HH:mm') }} <br>
        {{ $t('till') }}: {{ booking.period.end | moment('ddd D MMM - HH:mm') }}
      </small>

      <small
          v-if="getPeriodText(booking.period, 'description')"
          class="text-muted"
      >
        <em>{{ getPeriodText(booking.period, 'description') }}</em>
      </small>

      <ul class="list-comma mb-0 mt-2">
        <li
            v-for="(line, index) in booking.linesWithQuantity"
            v-bind:key="index"
        >
          <small v-if="+line.quantity !== 0"><em>{{ line.quantity }}x {{ line.name }}</em></small>
        </li>
      </ul>
    </div>

    <error-list
        v-if="!hideErrors"
        class="mt-3"
    >
    </error-list>
  </div>
</template>

<script>
import translationMixin from '../mixins/translationMixin';
import posMixin from '../mixins/posMixin';

export default {
  mixins: [translationMixin, posMixin],

  props: [
    'event',
    'booking',
    'hideErrors'
  ],

  computed: {
    /**
     * Get total amount.
     *
     * @return Number
     */
    totalAmount() {
      return this.booking.calculateTotalAmount(this.event);
    }
  }
}
</script>
